import styled from "@emotion/styled"



export const BtnSmall = styled.button`
padding:3px 12px;
font-size: 12px;
line-height:20px;
cursor:pointer;
user-select: none;
border:none;
border-radius: 3px;
font-weight: 500;
white-space: nowrap;
display:flex;
align-items: center;
`
export const BtnDefault = styled.button`
position: relative;
    display: inline-block;
    padding: 5px 16px;
    font-size: 14px;
    font-weight: 500;
    line-height: 20px;
    white-space: nowrap;
    vertical-align: middle;
    cursor: pointer;
    -webkit-user-select: none;
    user-select: none;
    border: 1px solid;
    border-radius: 6px;
`